export const COLORS = {
    primary: {
      main: '#A5276C', // Purple
      dark: '#302564', // Dark Blue
    },
    neutral: {
      white: '#FFFFFF',
      black: '#000000',
    },
    // Shades of primary colors for various UI elements
    purple: {
      light: '#C373A0', // Lighter shade of #A5276C
      medium: '#A5276C',
      dark: '#841F56',
    },
    blue: {
      light: '#443B89', // Lighter shade of #302564
      medium: '#302564',
      dark: '#251D4F',
    }
  };